import { forwardRef } from 'react';
import { cn } from '../utils';
import { SelectField } from "components/ui/select-field";

/* Delegates to the shared SelectField. It used to render a native <select>
   with `appearance-none` and a hand-placed ChevronDown — the trigger now draws
   its own, so the extra chevron and the ref to an HTMLSelectElement both went
   with the element they belonged to. The `label` + `options` API is unchanged,
   so no call site moves. */

interface SelectProps {
  label?: string;
  options: { value: string; label: string }[];
  value?: string;
  onChange?: (event: { target: { value: string; name?: string } }) => void;
  disabled?: boolean;
  name?: string;
  id?: string;
  className?: string;
  'aria-label'?: string;
}

export const Select = forwardRef<HTMLButtonElement, SelectProps>(
  ({ label, options, className, ...props }, ref) => (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label className="text-xs font-semibold text-content-muted dark:text-dark-400 uppercase tracking-wide">
          {label}
        </label>
      )}
      <SelectField
        ref={ref}
        triggerSize="sm"
        className={cn('w-full', className)}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </SelectField>
    </div>
  )
);

Select.displayName = 'Select';
